import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesSchemesOptionDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-schemes-option-delete',
	path: '/secure/admin/DeleteOptionScheme!default.jspa',
};
